import type { FC } from 'react'

import Highlight from '@/components/Highlight'

import type { PhoneBookType } from '../types'

type IProps = {
  item: PhoneBookType
  isSelected: boolean
  searchPhrase: string
  onClick: (item: PhoneBookType) => void
}

export const PhoneBookItem: FC<IProps> = ({ item, isSelected, onClick, searchPhrase }) => {
  const onClickHandler = () => {
    if (item.numbers) {
      onClick(item)
    }
  }
  return (
    <div
      className={`rounded px-2 py-2 ${
        !item.children
          ? 'flex cursor-pointer items-center justify-between hover:rounded hover:bg-gray-50'
          : 'font-bold'
      } ${isSelected && 'bg-gray-200'}`}
      onClick={() => onClickHandler()}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClickHandler()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="overflow-hidden text-ellipsis">
        <Highlight pattern={searchPhrase} text={item.name} />
      </div>
    </div>
  )
}
